import i18n from '@/i18n';

const keywordsShowOptions = [
  { label: i18n.t('all-keywords'), value: 'all' },
  { label: i18n.t('favorites'), value: 'favorited' },
  { label: i18n.t('unfavorited'), value: 'unfavorited' },
];

const keywordsEnginesOptions = [
  { label: i18n.t('everything'), value: '' },
  { label: i18n.t('organic-every'), value: 'se,sem' },
  { label: i18n.t('organic-desktop'), value: 'se' },
  { label: i18n.t('organic-mobile'), value: 'sem' },
  { label: i18n.t('google-maps'), value: 'map' },
];

const searchTypeOptions = [
  { label: i18n.t('search-type-exact'), value: 'exact' },
  { label: i18n.t('search-type-broad'), value: 'broad' },
];

export { keywordsShowOptions, keywordsEnginesOptions, searchTypeOptions };
